import React from 'react';

import { ZoomInIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';

import type { ViewPhotoProps } from './types';
import { useFullscreenImageViewer } from './useFullscreenImageViewer';
import { buildTestid } from '../../shared/lib/utils';

type ViewPhotoIconButtonProps = ViewPhotoProps & Omit<IconButtonProps, 'onClick'>;

const displayName = 'ViewPhotoIconButton';
const testid = buildTestid(displayName);

function ViewPhotoIconButton({
  url = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: ViewPhotoIconButtonProps): React.JSX.Element {
  const fullscreenImageViewer = useFullscreenImageViewer({ url });
  return (
    <IconButton
      disabled={!url}
      icon={<ZoomInIcon />}
      kind="secondary"
      onClick={fullscreenImageViewer}
      size="small"
      variant="flat"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

ViewPhotoIconButton.displayName = displayName;

export { ViewPhotoIconButton };
